module.exports = __webpack_public_path__ + "static/media/Calculator_Hero_Desktop.115c818b.png";